module.exports = __webpack_public_path__ + "img/identity-camera.5beacb05.png";